import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";

export const getServiceComponents = (params?: any) =>
  new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/service-components`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

export const getServiceComponentById = (id: number | string) =>
  new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/service-components/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

export const createServiceComponent = (payload: any) =>
  new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/service-components`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

export const updateServiceComponent = (id: number | string, payload: any) =>
  new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/service-components/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });

export const deleteServiceComponent = (id: number | string) =>
  new Promise((resolve, reject) => {
    api
      .delete(`${BASE_URL}/api/v1/service-components/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
